import styled from "styled-components";

export const SearchSuggestionSingleStyled = styled.button`
  text-align: right;

  padding: 6px 12px;
  border-radius: 14px;
  box-shadow: 0 2px 6px 0 rgba(42, 46, 67, 0.1);
  border: solid 0.5px rgba(42, 46, 67, 0.1);
  background-color: #ffffff;
  width: 100%;

  margin-bottom: 6px;
`;
